import api, { EXTREMELY_LONG_REQUEST_DURATION } from '../config/api'

export const MEETING_TYPE_1ON1 = 1;
export const MEETING_TYPE_TEAM = 2; // legacy only; deprecate soon
export const MEETING_TYPE_GROUP = 3;

const MeetingsService = {
  // 'recache' tells the backend to invalidate the remote-calendar cache
  // for the same date range in the request
  getAll: ({
    endTime,
    startTime,
    attendeeEmail: email,
    meetingType: type,
    recache,
    shouldPassStartTimeToAPI,
    excludeId,
  }) => {
    let params = {
      endTime,
      email,
      type,
      recache
    }

    if (shouldPassStartTimeToAPI) {
      params = { ...params, startTime }
    }

    if (excludeId) {
      params = { ...params, excludeId }
    }

    return api.get(`${wbConfig.baseUrl}/restapi/meetings/`, { params })
  },

  get: (id) => api.get(`${wbConfig.baseUrl}/restapi/meetings/fetch/${id}`),

  getLatest: (id) => api.get(`${wbConfig.baseUrl}/restapi/meetings/${id}/latest`),

  getSeries: ({ id, startTime, endTime }) => {
    let url = `${wbConfig.baseUrl}/restapi/meetings/${id}/series`
    url += `?startTime=${startTime}&endTime=${endTime}`
    return api.get(url, { cancelable: true, timeout: EXTREMELY_LONG_REQUEST_DURATION })
  },

  getSeriesMergers: ({
    id, startTime, endTime, masterRef
  }) => {
    let url = `${wbConfig.baseUrl}/restapi/meetings/${id}/series`
    url += `?startTime=${startTime}&endTime=${endTime}&masterRef=${masterRef}`
    return api.get(url, { cancelable: true, timeout: EXTREMELY_LONG_REQUEST_DURATION })
  },

  mergeSeries: ({
    id, startTime, endTime, masterRef
  }) => {
    let url = `${wbConfig.baseUrl}/restapi/meetings/${id}/series`
    url += `?startTime=${startTime}&endTime=${endTime}`
    return api.post(url, {
      masterRef
    })
  },

  getLegacyData: (id) => (
    api.get(`${wbConfig.baseUrl}/restapi/meetings/${id}/legacydata`)
  ),

  update: (meeting) => {
    const { id } = meeting
    return api.put(`${wbConfig.baseUrl}/restapi/meetings/${id}`, meeting)
  },

  remove: (meeting) => {
    const { id } = meeting
    return api.delete(`${wbConfig.baseUrl}/restapi/meetings/${id}`)
  },

  create: (meeting) => (
    api.post(`${wbConfig.baseUrl}/restapi/meetings`, meeting)
  ),

  getMyManagersAndReports: () => (
    api.get(`${wbConfig.baseUrl}/restapi/meetings/reports`, { cancelable: true })
  ),

  getMeetingPerformance: () => (
    api.get(`${wbConfig.baseUrl}/restapi/meetings/productivity`)
  ),

  addTopicOrTakeToTargetMeeting: (source, destinationMeetingId, addTake) => {
    const data = {
      meetingId: destinationMeetingId,
      includeTakeaways: addTake
    };

    if (source.addedType === 'topic') {
      return api.post(`${wbConfig.baseUrl}/restapi/meetings/${source.curMeetingId}/topics/${source.curTopicId}/copy`, data);
    } if (source.addedType === 'take') {
      return api.post(`${wbConfig.baseUrl}/restapi/meetings/${source.curMeetingId}/topics/${source.curTopicId}/takeaways/${source.curTakeId}/copy`, data);
    }
  },

  saveActionItemAsTopic (meetingId, id, context) {
    const data = new FormData()
    data.append('YII_CSRF_TOKEN', window.getYiiToken())
    data.append('meetingId', meetingId)
    data.append('items', [id]);
    if (context) {
      data.append('context', context);
    }
    return api.post(`${wbConfig.baseUrl}/meeting/saveMeetingAI`, data);
  },

  saveObjectiveAsTopic (meetingId, id, context) {
    const data = new FormData()
    data.append('YII_CSRF_TOKEN', window.getYiiToken())
    data.append('meetingId', meetingId)
    data.append('items', [id]);
    if (context) {
      data.append('context', context);
    }

    return api.post(`${wbConfig.baseUrl}/meeting/saveMeetingObjective`, data);
  },

  saveWorkstreamAsTopic (meetingId, id, context) {
    const data = new FormData()
    data.append('YII_CSRF_TOKEN', window.getYiiToken())
    data.append('meetingId', meetingId)
    data.append('items', [id]);
    if (context) {
      data.append('context', context);
    }

    return api.post(`${wbConfig.baseUrl}/meeting/saveMeetingWs`, data);
  },

  saveKrAsTopic (meetingId, id, context) {
    const data = new FormData()
    data.append('YII_CSRF_TOKEN', window.getYiiToken())
    data.append('meetingId', meetingId)
    data.append('items', [id]);
    if (context) {
      data.append('context', context);
    }

    return api.post(`${wbConfig.baseUrl}/meeting/saveMeetingKR`, data);
  },

  makeAllTopicsRecurring: (meeting) => api.post(`${wbConfig.baseUrl}/restapi/meetings/${meeting.id}/addAllRecurringTopics`),

  removeAllRecurringTopics: (meeting) => api.post(`${wbConfig.baseUrl}/restapi/meetings/${meeting.id}/removeAllRecurringTopics`),

  copyAllTopics: (source, destinationMeetingId, addTake) => {
    const data = {
      meetingId: destinationMeetingId,
      includeTakeaways: addTake
    };

    return api.post(`${wbConfig.baseUrl}/restapi/meetings/${source.id}/copyAllTopics`, data);
  },

  legacyPing: (meeting) => {
    const data = new FormData()
    data.append('YII_CSRF_TOKEN', window.getYiiToken())
    data.append('meetingId', meeting.id)
    return api.post(`${wbConfig.baseUrl}/meeting/pingTeam`, data)
  },

  sendSummary: (meeting) => {
    const {
      id, rate
    } = meeting

    const params = { action: 'send' };
    if (rate) {
      params.rate = true;
    }

    return api.get(
      `${wbConfig.baseUrl}/restapi/meetings/${id}/summary`,
      { params }
    );
  },

  getIntegrationConflict: (id) => (
    api.get(`/wb/restapi/integration/transfer/query/${id}`)
  ),

  resolveIntegrationConflict: (id, decision) => (
    api.get(`/wb/restapi/integration/transfer/${decision}/${id}`)
  ),
  getLogo: () => api.get(`${wbConfig.baseUrl}/meeting/getLogo`),
}

export default MeetingsService
